import { Flex, Spinner } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { PRIMARY } from '../tokens'
import { useNavigate } from 'react-router-dom'
import { useFormColors } from './FormThemeContext'
import { useAppFormContext } from './AppForm'

interface FormActionsProps {
  submitLabel?: string
  cancelPath: string
  isSubmitting?: boolean
}

export function FormActions({
  submitLabel = 'Guardar',
  cancelPath,
  isSubmitting: isSubmittingOverride,
}: FormActionsProps) {
  const navigate = useNavigate()
  const c = useFormColors()
  const ctx = useAppFormContext()
  const submitting = isSubmittingOverride ?? ctx.isSubmitting

  return (
    <Flex justifyContent="flex-end" gap={3} mt={6}>
      <motion.button
        type="button"
        whileTap={{ scale: 0.97 }}
        style={{
          height: 44,
          padding: '0 1.4rem',
          borderRadius: 12,
          color: c.textSecondary,
          background: 'transparent',
          border: `1px solid ${c.border}`,
          fontWeight: 600,
          cursor: 'pointer',
        }}
        onClick={() => navigate(cancelPath)}
      >
        Cancelar
      </motion.button>
      <motion.button
        type="submit"
        disabled={submitting}
        whileHover={submitting ? undefined : { y: -1 }}
        whileTap={submitting ? undefined : { scale: 0.97 }}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          height: 44,
          padding: '0 1.5rem',
          background: PRIMARY,
          color: 'white',
          borderRadius: 12,
          border: 'none',
          fontWeight: 650,
          cursor: submitting ? 'wait' : 'pointer',
          opacity: submitting ? 0.8 : 1,
        }}
      >
        {submitting && <Spinner size="sm" color="white" />}
        {submitting ? 'Guardando…' : submitLabel}
      </motion.button>
    </Flex>
  )
}
